import type z from 'zod'
import { schema as clickWrapSchema } from '../ClickWrap/schema'
import { nullSafeFirestoreTimestamp, nullSafeString } from '../shared/schema'

export const schema = clickWrapSchema
  .extend({
    userId: nullSafeString(''),
    createdAt: nullSafeFirestoreTimestamp(new Date()),
  })
  .omit({ updatedAt: true }) // clickWrapUpdate cannot be updated (it extends clickWrap so explicitly omitting this field)

export const empty = Object.freeze(
  schema.parse({
    clickWrapDescription: '',
    clickWrapName: '',
    clickWrapRoles: [],
    clickWrapState: 1,
    clickWrapUrl: '',
    clickWrapDate: { seconds: 0, nanoseconds: 0 },
    userId: '',
    createdAt: { seconds: 0, nanoseconds: 0 },
  })
)

export interface FirestoreClickWrapUpdate extends z.infer<typeof schema> {}
